<template>
  <div class="container mb-0 pt-0 mt-60">
  <div class="vl-parent">
        <loading v-model:active="isLoading"
                 :can-cancel="true"
                 :is-full-page="fullPage"/>
   </div>
      <div class="section-content">
        <form class="forms-sample" @submit.prevent="uploadFile"  style="width:100%">
          <div class="form-group row">
            <label class="col-sm-3 col-form-label" >Slider Header</label>
            <div class="col-sm-9">
                    <input class="form-control" v-model="sliderHeader" type="text" placeholder="Slider Header">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label" >Slider Title</label>
            <div class="col-sm-9">
                    <input class="form-control" v-model="sliderTitle" type="text" placeholder="Slider Title">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label" >Slider Slogan</label>
            <div class="col-sm-9">
                    <input class="form-control" v-model="sliderSlogan" type="text" placeholder="Slider Slogan">
            </div>
           
          </div>
          <div class="form-group row">
                      <label class="col-sm-3 col-form-label">Slider Image</label>
                      <input type="file" @change="onFileChange" name="img[]" class="file-upload-default">
                      <div class="input-group col-sm-9">
                        <input type="text" disabled class="form-control file-upload-info"   placeholder="Upload Image">
                        <div class="input-group-append">
                          <button  class="file-upload-browse btn btn-info" type="button">Upload</button>                          
                        </div>
                      </div>
            </div>
            <input class="btn btn-success mr-2" type="submit" name="submit" value="Submit">
        </form>
       </div>
   </div>
</template>
<script>
import $ from "jquery";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default{
  components: {
    Loading
  },
  data() {
    return {
      sliderHeader:'',
      sliderTitle:'',
      sliderSlogan:'',
      fileToUpload: null,
      isLoading: false,
      fullPage: true,
    };
  },
  computed:{
    url(){
      return this.$store.state.url;
    }

  },
  methods: {
    onFileChange(event) {
      this.fileToUpload = event.target.files[0];
    },
    async uploadFile() {
      this.isLoading=true;
      const formData = new FormData();
      formData.append('sliderHeader', this.sliderHeader);
      formData.append('sliderTitle', this.sliderTitle);
      formData.append('sliderSlogan', this.sliderSlogan);
      formData.append('file', this.fileToUpload);
      axios.post(this.url+'slidercreated',formData).then(response=>{
         this.isLoading=false;
         this.noticeTitle='';
         $('.file-upload-info').val('');
         toast.success("Slider has created successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.sliderHeader="";
        this.sliderTitle="";
        this.sliderSlogan="";

      })

    }
  }
}
</script>